import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketStatus'
})
export class TicketStatusPipe implements PipeTransform {

  transform(value: string): string | null {
    switch(value) {
      case 'created':
        return 'Creado';
      case 'reserved':
        return 'Reservado';
      case 'paid':
        return 'Pagado';
      case 'cancelled':
        return 'Cancelado';
      case 'refunded':
        return 'Reembolsado';
      case 'used':
        return 'Utilizado';
    }
    return value;
  }
}